import * as React from 'react';
import styled from 'styled-components';
import {P1, P2, SectionTitle} from '../Kit/Kit';
import {BodyContainer} from "../Container/Container";
import bg from '../../assets/img/section1BG.jpg';
import Link from 'gatsby-link';

const StyledContainer = BodyContainer.extend`
  padding-top: 16px;

  @media (min-width: 500px) {
    background: url(${bg}) top no-repeat;
    background-size: contain;
    padding-top: 60px;
    padding-bottom: 0;
  }
  
  @media(min-width: 992px) {
    padding-top: 120px;
    padding-bottom: 0;
  }
`;

const ProductContainer = styled.div`
  margin-top: 16px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  
  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ProductCard = styled.div`
  display: grid;
  grid-row-gap: 8px;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  
  @media(min-width: 992px){
    grid-row-gap: 20px;
  }
  
  p {
    text-align: center;
  }
  
  a {
    color: initial;
    text-decoration: none;
  }
`;

const ProductImg = styled.img`
  width: 100%;
`;

const StyledSectionTitle = SectionTitle.extend`
  margin-bottom: 16px;
  
  @media(min-width: 768px){
    margin-bottom: 20px;
  }
  
  @media(min-width: 992px) {
    margin-bottom: 24px;
  }
`;

const SectionDescription = P1.extend`
  margin-bottom: 24px;
  
  @media(min-width: 768px){
    margin-bottom: 30px;
  }
  
  @media(min-width: 992px) {
    margin-bottom: 40px;
  }
`;

const Section1Home = (props) => {
    const {
        header,
        paragraph,
        image_one,
        image_two
    } = props.data;
    return (
      <StyledContainer>
          <StyledSectionTitle>{header}</StyledSectionTitle>
          <SectionDescription>{paragraph}</SectionDescription>
          <ProductContainer>
              <ProductCard>
                  <Link to='/product-info' title="H & N Group Wholsale Seafood Options">
                      <ProductImg src={image_one.source_url} alt={image_one.alt_text}/>
                  </Link>

                  <Link to='/product-info' title="H & N Group Wholsale Seafood Options">
                      <SectionTitle>{image_one.title}</SectionTitle>
                  </Link>
                  <P2
                    dangerouslySetInnerHTML={{__html: image_one.caption}}
                  />
              </ProductCard>

              <ProductCard>
                  <Link to='/product-info' title="H & N Group Wholsale Seafood Options">
                      <ProductImg src={image_two.source_url} alt={image_one.alt_text}/>
                  </Link>
                  <Link to='/product-info' title="H & N Group Wholsale Seafood Options">
                      <SectionTitle>{image_two.title}</SectionTitle>
                  </Link>
                  <P2
                    dangerouslySetInnerHTML={{__html: image_two.caption}}
                  />
              </ProductCard>
          </ProductContainer>

      </StyledContainer>
    );
};

export default Section1Home;



// WEBPACK FOOTER //
// ./src/components/Home/Section1Home.js